import { Button, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { AssetInput } from "src/generated/graphqlTypes";
import {
  ConstructionDocumentPicker,
  useConstructionDocumentPicker,
} from "src/routes/libraries/plan-package-v2/components/ConstructionDocumentPicker";

type ImportFromDocumentModalProps = {
  /** Called with the chosen document's asset, a new file already in S3; the caller starts the import. */
  onImport: (asset: AssetInput) => Promise<void> | void;
};

/**
 * Picks the construction document Blueprint AI imports plan data from: one of the plan's Plan documents, or a new
 * upload. Open it with `aiMode` so the header picks up the Blueprint AI logo and gradient title.
 */
export function ImportFromDocumentModal(props: ImportFromDocumentModalProps) {
  const { onImport } = props;
  const { closeModal } = useModal();
  const picker = useConstructionDocumentPicker(async (asset) => {
    await onImport(asset);
    closeModal();
  });

  return (
    <>
      <ModalHeader>Import From Document</ModalHeader>
      <ModalBody>
        <ConstructionDocumentPicker picker={picker} />
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="text" onClick={closeModal} />
        <Button
          label="Import"
          variant="ai"
          disabled={picker.missing || (picker.submitting && "Importing...")}
          onClick={picker.submit}
        />
      </ModalFooter>
    </>
  );
}
